/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KalendereintragDto } from '../../models/kalendereintrag-dto';

export interface GetKalendereintraegeForMitarbeiter$Json$Params {

/**
 * ID des Mitarbeiters
 */
  mitarbeiterId: string;

/**
 * Datum ab dem Kalendereinträge zurückgegeben werden sollen. (Inklusive)
 */
  From: string;

/**
 * Datum bis wann Kalendereinträge zurückgegeben werden sollen. (Inklusive)
 */
  To: string;
  IncludeInactiveMitarbeiter?: boolean;
}

export function getKalendereintraegeForMitarbeiter$Json(http: HttpClient, rootUrl: string, params: GetKalendereintraegeForMitarbeiter$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KalendereintragDto>>> {
  const rb = new RequestBuilder(rootUrl, getKalendereintraegeForMitarbeiter$Json.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.query('From', params.From, {});
    rb.query('To', params.To, {});
    rb.query('IncludeInactiveMitarbeiter', params.IncludeInactiveMitarbeiter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KalendereintragDto>>;
    })
  );
}

getKalendereintraegeForMitarbeiter$Json.PATH = '/v1/mitarbeiter/{mitarbeiterId}/kalendereintraege';
